import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-ganhador {
  padding: 56px 0;
  background: #222;
  text-align: center;
}

#partiu-gp-ganhador .eyebrow {
  margin: 0 0 4px;
  color: #fff;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
}

#partiu-gp-ganhador .titulo {
  margin: 0 0 8px;
  color: #fff;
  font-family: 'SantanderHeadline';
  font-size: 30px;
  font-weight: 800;
  line-height: 34px;
}

#partiu-gp-ganhador .subtitulo {
  margin: 0;
  color: #fff;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}

@media (min-width: 992px) {
  #partiu-gp-ganhador {
    padding: 76px 0 86px;
  }

  #partiu-gp-ganhador .titulo {
    margin: 0 0 28px;
    font-size: 72px;
    line-height: 80px;
  }

  #partiu-gp-ganhador .subtitulo {
    font-family: 'SantanderHeadline';
    font-size: 50px;
    line-height: 38px;
  }

  #partiu-gp-ganhador .eyebrow {
    font-family: 'SantanderHeadline';
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 16px;
  }
}
`;

export default styles;